import { FC } from 'react';
import classNames from 'classnames';
import { Container } from 'lib/components';

export interface FooterContentProps {
  className?: string;
}

export const FooterContent: FC<FooterContentProps> = ({ className, ...props }) => (
  <Container className={classNames(`flex justify-center items-center`, className)} {...props} />
);
